import moment from 'moment-timezone';

// Action Types
export const LOAD = 'DEEP_LINK_LOAD';
export const LOAD_START = `${LOAD}_START`;
export const LOAD_SUCCESS = `${LOAD}_SUCCESS`;
export const LOAD_FAIL = `${LOAD}_FAIL`;

export const REFRESH = 'DEEP_LINK_REFRESH';
export const REFRESH_SUCCESS = `${REFRESH}_SUCCESS`;
export const REFRESH_FAIL = `${REFRESH}_FAIL`;

export const TOKEN_EXPIRED = 'DEEP_LINK_TOKEN_EXPIRED';
export const RESET_DEEP_LINKS = 'RESET_DEEP_LINKS';

const hasExpired = expiry => {
  const now = moment();
  const expiredTime = moment(expiry);
  return expiredTime.isBefore(now);
};

export function refresh(payload) {
  const { expiry, token } = payload;

  if (hasExpired(expiry)) {
    return {
      type: TOKEN_EXPIRED,
      payload,
    };
  }

  return {
    type: REFRESH,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/deep-links/${token}`,
      method: 'get',
    },
  };
}

export function load({ deepLinkAction, expiry, urlTemplate }, deepLink) {
  if (deepLink && deepLink.token && !hasExpired(deepLink.expiry)) {
    return refresh(deepLink);
  }
  return {
    type: LOAD,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/deep-links',
      method: 'post',
      params: {
        expiry,
        action: deepLinkAction,
        url: urlTemplate,
      },
    },
  };
}

export const resetState = () => ({ type: RESET_DEEP_LINKS });
